export default __webpack_public_path__ + "static/media/UserDefaultPic.e9d84311.png";